module.exports = __webpack_public_path__ + "img/Avatar-12.2125332a.svg";